import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import DebouncedButton from "../DebouncedButton";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  container: {
    [breakpoints.down("sm")]: {
      width: typography.pxToRem(290)
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  hidden: {
    visibility: "hidden"
  }
}));
export default (({
  onSubmit,
  isSubmitDisabled,
  isSubmitHidden,
  className,
  children = "Submit"
}) => {
  const styles = useStyles();
  return onSubmit && /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className, isSubmitHidden && styles.hidden)
  }, /*#__PURE__*/React.createElement(DebouncedButton, {
    type: "submit",
    onClick: onSubmit,
    disabled: isSubmitDisabled
  }, children));
});